import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

import { PaymentSwitchingData } from '../entities';

@Injectable({ providedIn: 'root' })
export class ScoringSyncFacade {
    private readonly _data = new BehaviorSubject<PaymentSwitchingData | null>(null);

    get isScoringSwitchedOn$(): Observable<boolean> {
        return this._data.pipe(map((data) => !!data?.payinActive));
    }

    setData(data: PaymentSwitchingData): void {
        this._data.next(data);
    }
}
